import { Box, Typography, Stack } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";

const FooterStyle = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1, 2),
  textAlign: "right",
  borderTop: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
  backgroundColor: theme.palette.mode === 'dark' ? '#1e1e1e' : '#ffffff',
  marginTop: "auto",
  position: "relative",
  zIndex: 1000,
}));

const PoweredByText = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  letterSpacing: "0.2px",
  color: theme.palette.mode === 'dark' ? '#9e9e9e' : '#666666',
  fontSize: "0.7rem",
  lineHeight: 1.4,
  "& strong": {
    color: theme.palette.mode === 'dark' ? '#64b5f6' : '#1976d2', 
    fontWeight: 600,
  },
}));

const CopyrightText = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  letterSpacing: "0.15px",
  color: theme.palette.text.disabled,
  fontSize: "0.65rem",
  lineHeight: 1.4,
  fontFamily: theme.typography.fontFamily,
}));

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <FooterStyle>
      <Stack spacing={0.3} alignItems="flex-end" justifyContent="flex-end">
        <PoweredByText>
          Powered by <strong>Amik Tech</strong>
        </PoweredByText>
        <CopyrightText>
          © {currentYear} Amik Tech. All rights reserved.
        </CopyrightText>
      </Stack>
    </FooterStyle>
  );
}

